import React from 'react';
import PropTypes from 'prop-types';

import { reportWarning } from 'helpers/error-logging';
import SkuOrderFlyout from 'features/Sku/shared/SkuOrderFlyout';

import { isOrderLineItem, isReservationLineItem } from './SkuPayoutReports.types';
import {
  normalizeOrderLineItemToPartnerOrder,
  normalizeReservationLineItemToPartnerOrder,
} from './SkuPayoutOrderFlyout.normalizers';

const SkuPayoutOrderFlyout = ({ id, lineItem }) => {
  let order = null;

  if (isOrderLineItem(lineItem)) {
    order = normalizeOrderLineItemToPartnerOrder(lineItem);
  } else if (isReservationLineItem(lineItem)) {
    order = normalizeReservationLineItemToPartnerOrder(lineItem);
  } else if (lineItem != null) {
    reportWarning('SkuPayoutOrderFlyout: unrecognized lineItem type', {
      lineItem: JSON.stringify(lineItem),
    });
  }

  return (
    <SkuOrderFlyout
      flyoutId={id}
      order={order}
      // No onFulfill / onCancelOrder / onItemOutOfStock — payout flyout is read-only.
    />
  );
};

const payoutLineItemShape = PropTypes.shape({
  orderId: PropTypes.string,
  reservationId: PropTypes.number,
  adjustmentId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  className: PropTypes.string,
});

SkuPayoutOrderFlyout.propTypes = {
  id: PropTypes.string.isRequired,
  lineItem: payoutLineItemShape,
};

export default SkuPayoutOrderFlyout;
